import React, { Component, ReactNode } from 'react';
import { StyledMobileMeasurements } from './MobileMeasurementsStyle';
import { Platform, Orientation, WriteDirection } from 'sofa-reborn-react';
import { KompisText } from '@inter-ikea-kompis/react-components';
import { SkapaTheme } from '@inter-ikea-kompis/themes';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums';

type Props = {
	platform: Platform;
	toolsBottom: number;
	measurements: string;
	orientation: Orientation;
	writeDirection: WriteDirection;
};

/**
 * React component.
 *
 */
export default class MobileMeasurements extends Component<Props> {
	public getAriaLabel = (measurements: string): string => {
		const replaced = measurements.replace(new RegExp('×', 'g'), 'times');
		return replaced;
	};

	/**
	 * React render method.
	 *
	 * @returns React node.
	 */
	public render(): ReactNode {
		const { props } = this;

		return (
			<KompisText theme={SkapaTheme} type={ThemeFontStyleTypeEnum.bodySmall}>
				<StyledMobileMeasurements
					orientation={props.orientation}
					writeDirection={props.writeDirection}
					toolsBottom={props.toolsBottom}
					aria-label={this.getAriaLabel(props.measurements)}
				>
					{props.measurements}
				</StyledMobileMeasurements>
			</KompisText>
		);
	}
}
